var _rect, _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBieubIrregular = function SvgBieubIrregular(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 20,
    fill: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 26,
    width: 19,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4914 41.3951C39.6677 41.3951 39 42.0629 39 42.8866V43.5529C39 44.3766 39.6677 45.0443 40.4914 45.0443H45.1598C45.8436 45.0443 46.3979 45.5986 46.3979 46.2824L46.3979 48.6258C46.3979 49.566 47.1601 50.3282 48.1004 50.3282H48.8609C49.8012 50.3282 50.5634 49.566 50.5634 48.6258V46.2824C50.5634 45.5986 51.1177 45.0443 51.8015 45.0443H56.378C57.2017 45.0443 57.8694 44.3766 57.8694 43.5529V42.8866C57.8694 42.0629 57.2017 41.3951 56.378 41.3951H40.4914Z",
    fill: "#E79393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9603 37.3065C54.9676 37.0729 58.074 34.4472 57.8989 31.4418C57.7237 28.4364 54.3332 26.1894 50.326 26.4229C46.3188 26.6565 43.2123 29.2822 43.3875 32.2876C43.5626 35.293 46.9531 37.54 50.9603 37.3065ZM50.6976 34.018C52.3457 33.922 53.6268 32.901 53.559 31.7376C53.4912 30.5742 52.1002 29.709 50.4521 29.805C48.8039 29.9011 47.5228 30.9221 47.5906 32.0855C47.6584 33.2488 49.0495 34.1141 50.6976 34.018Z",
    fill: "#E69393"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.4719,
    y: 15.019,
    width: 26.7275,
    height: 43.9598,
    fill: "#DEAAAA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 12,
    width: 8,
    height: 46
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1719 34.9856C31.1719 47.672 33.6535 57.9716 36.7106 57.9716C37.4767 57.9716 38.2065 57.3253 38.8684 56.1606C36.8791 52.6618 35.4836 44.494 35.4836 34.9856C35.4836 25.4772 36.8791 17.3094 38.8684 13.8112C38.2065 12.6463 37.4767 12 36.7106 12C33.6535 12 31.1719 22.2996 31.1719 34.9856Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1719 34.9856C31.1719 47.672 33.6535 57.9716 36.7106 57.9716C37.4767 57.9716 38.2065 57.3253 38.8684 56.1606C36.8791 52.6618 35.4836 44.494 35.4836 34.9856C35.4836 25.4772 36.8791 17.3094 38.8684 13.8112C38.2065 12.6463 37.4767 12 36.7106 12C33.6535 12 31.1719 22.2996 31.1719 34.9856Z",
    fill: "url(#paint0_linear)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 13,
    width: 8,
    height: 44
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.485 56.1611L35.485 13.8118L42.247 13.8118L42.247 56.1611L35.485 56.1611Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8665 56.1611C36.8789 52.6627 35.485 44.4946 35.485 34.9864C35.485 25.4777 36.8789 17.3102 38.8665 13.8118C40.8555 17.3102 42.2471 25.4777 42.2471 34.9864C42.2471 44.4946 40.8555 52.6627 38.8665 56.1611Z",
    fill: "#8D8D8D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 23,
    width: 26,
    height: 24
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5257 44.0641C30.1641 45.9146 28.3708 47.1215 26.5203 46.7599L10.8233 43.6924C8.97287 43.3308 7.76592 41.5375 8.12754 39.6871L10.7318 26.3605C11.0547 24.7084 12.6557 23.6309 14.3078 23.9537L14.8126 24.0524C16.1859 24.3207 17.0817 25.6516 16.8133 27.0249C16.5449 28.3982 17.4406 29.7291 18.814 29.9975L24.2733 31.0643C25.6466 31.3327 26.9774 30.437 27.2458 29.0636C27.5142 27.6903 28.845 26.7946 30.2183 27.063L30.7231 27.1616C32.3753 27.4845 33.4528 29.0855 33.13 30.7376L30.5257 44.0641ZM14.4786 38.9711L24.9111 41.0098L25.7222 36.8592L15.2897 34.8205L14.4786 38.9711Z",
    fill: "#E69393"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.8813,
    height: 66.4689,
    transform: "matrix(-0.981435 -0.191793 -0.191793 0.981435 39.135 3.33984)",
    fill: "#DF6D65"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 40.9179,
    y1: 38.1293,
    x2: 24.3311,
    y2: 32.9196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6A6A6"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBieubIrregular);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/bieub-irregular.e8ec166e7739922e7a553cb2560267eb.blank.svg";